import StatusIndicator from 'components/StatusIndicator';
import useStyles from 'features/Status/components/StatusHistory/StatusHistoryChart/StatusHistoryTooltip.styles';

type StatusHistoryTooltipProps = {
  statusColour: string;
  state: string;
  time: string;
};

export const StatusHistoryTooltip = ({ statusColour, state, time }: StatusHistoryTooltipProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <StatusIndicator color={statusColour} />
      <div className={classes.state}>{state}</div>
      <div className={classes.state}> · </div>
      <div className={classes.state}>{time}</div>
    </div>
  );
};

export default StatusHistoryTooltip;
